
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lista-de-desejos",
      function () {
        return require("private-next-pages/lista-de-desejos.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lista-de-desejos"])
      });
    }
  